import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import homeImageBackground from "../assets/images/homeBackground.png";
import { setImage } from "../redux/image";
import { clearInstructions } from "../redux/instructions";
import { setPrompt } from "../redux/recipes";
import {
  clearTitle,
  setDishImage,
  setDishNumber,
  setRecipeAllImage,
} from "../redux/title";
import GenerateDishes from "./open-ai/GenerateDishes";
import { playAudio } from "../utils/btnAudio";
import {
  IoArrowBack,
  IoArrowBackCircleSharp,
  IoArrowForwardCircleSharp,
} from "react-icons/io5";
import { useDarkMode } from "../DarkModeProvider";
// import parse from 're'

export default function DishesPage() {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const contentRef = useRef(null);
  const { prompt } = useSelector((state) => state.prompt);
  const { title } = useSelector((state) => state.title);
  const { dish1, dish2, dish3, response } = useSelector((state) => state.dish);
  const { ingredients } = useSelector((state) => state.ingredients);
  const { dishTokens, recipeTokens } = useSelector((state) => state.tokens);

  const [history, setHistory] = useState([]);

  const [displayedText, setDisplayedText] = useState("");

  const {
    Culture,
    FreeFlow,
    IncludedIngredients,
    ExcludedIngredients,
    Description,
    Occasion,
    Language,
  } = ingredients;

  const getPromptForDish = (dish1) => {
    "Give me a detailed recipe with cooking instructions for Dish {X}.";
    return `Give me a detailed recipe with cooking instructions for Dish ${dish1} that ${FreeFlow}  ${
      IncludedIngredients
        ? `and  includes the ingredients ${IncludedIngredients}`
        : ""
    },  ${
      ExcludedIngredients ? `but does not contain ${ExcludedIngredients}` : ""
    }.  ${Description ? `It should be ${Description}` : ""}  ${
      Occasion ? `and be suit no able for ${Occasion}` : ""
    }  ${Language ? `Please write the dish in ${Language}` : ""}`;
  };

  const findVariant = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to view these dishes again, and your search token will conclude",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, I am sure!",
      denyButtonText: `No, Cancel it!`,
      // showCloseButton: true,
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isDenied) {
        return;
      } else {
        if (dishTokens <= 0) {
          Swal.fire({
            icon: "info",
            title: "You are out of Search Tokens",
            showConfirmButton: true,
            timer: 2000,
          });

          return;
        }

        setDisplayedText("");
        setHistory([
          ...history,
          {
            role: "user",
            content: prompt,
          },
          {
            role: "system",
            content: JSON.stringify(response),
          },
          {
            role: "user",
            content:
              "Find 3 varient dishes with the same ingredients as before.",
          },
        ]);
      }
    });
  };

  // handle back button
  const handleBack = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to view these dishes again, and your search token will conclude",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, I am sure!",
      denyButtonText: `No, Cancel it!`,
      // showCloseButton: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result.isDenied) {
        return;
      } else {
        navigate("/discover-dishes");
      }
    });
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [displayedText]);

  const onFinalClick = (dishNumber, imageUrl) => {
    if (recipeTokens <= 0) {
      Swal.fire({
        icon: "info",
        title: "You don't have enough recipe tokens",
        showConfirmButton: true,
        timer: 2000,
      });
      return;
    }
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: "By proceeding, you will lose a search token and this can not be un done",
    //   icon: "warning",
    //   showDenyButton: true,
    //   confirmButtonText: "Yes, Proceed!",
    //   denyButtonText: `No`,
    //   showCloseButton: true,
    //   dangerMode: true,
    // }).then(async (result) => {
    //   if (result.isConfirmed) {
    dispatch(setDishNumber(dishNumber));
    dispatch(setImage(""));
    dispatch(clearInstructions());
    dispatch(clearTitle());

    dispatch(setImage(imageUrl));
    if (dishNumber > 0 && dishNumber < 4 && imageUrl && imageUrl?.length > 0) {
      dispatch(
        setDishImage({
          dishNumber,
          url: imageUrl,
        })
      );
      dispatch(
        setRecipeAllImage({
          dishNumber,
          url: imageUrl,
        })
      );
    }
    navigate(`/dishe-details`);
    //   }
    // });
  };

  const onDishClick = (dish) => {
    const { dishNumber, dishName, imageUrl } = dish;
    dispatch(setPrompt(getPromptForDish(dishName)));

    onFinalClick(dishNumber, imageUrl);
  };

  return (
    <section className="relative">
      {/* h-[calc(100%+2rem)] */}

      <div className="h-full">
        <article ref={contentRef} className="overflow-y-auto">
          {/* Article content */}
          <div className="text-lg text-gray-400">
            {/* <div className="flex w-full justify-between">
              <div onClick={handleBack} className="my-3 cursor-pointer">
                <IoArrowBackCircleSharp
                  size={40}
                  color={isDarkMode ? "white" : "black"}
                />
              </div>

              {title && (
                <div
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="my-3 cursor-pointer"
                >
                  <IoArrowForwardCircleSharp
                    size={50}
                    color={isDarkMode ? "white" : "black"}
                  />
                </div>
              )}
            </div> */}

            <div className="">
              <GenerateDishes
                prompt={`${prompt}`}
                history={history ? history : null}
                displayedText={displayedText}
                setDisplayedText={setDisplayedText}
                onDishClick={onDishClick}
                getVariant={findVariant}
                handleBackClick={handleBack}
                recipeTitle={title}
              />
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
